import { href, redirect, RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const valwinAdmin: RouteObject[] = [
  {
    path: ROUTES.admin.root,
    loader: ({ params }) =>
      redirect(href(ROUTES.admin.groups.root, { group: params.group! })),
  },
  {
    path: ROUTES.admin.groups.root,
    lazy: async () => {
      const { GroupAdminPage } =
        await import('../../pages/valwin-admin/groups/group-admin/GroupAdmin.page');

      return { Component: GroupAdminPage };
    },
  },
  {
    path: ROUTES.admin.groups.add,
    lazy: async () => {
      const { CreateGroupPage } =
        await import('../../pages/valwin-admin/groups/create-group/CreateGroup.page');

      return { Component: CreateGroupPage };
    },
  },
  {
    path: ROUTES.admin.groups.detail,
    loader: ({ params }) =>
      redirect(
        href(ROUTES.admin.groups.infos, {
          group: params.group!,
          pharmacyGroupId: params.pharmacyGroupId!,
        })
      ),
  },
  {
    path: ROUTES.admin.groups.features,
    lazy: async () => {
      const { GroupFeaturesPage } =
        await import('../../pages/valwin-admin/groups/group-features/GroupFeatures.page');

      return { Component: GroupFeaturesPage };
    },
  },
  {
    path: ROUTES.admin.groups.infos,
    lazy: async () => {
      const { EditGroupInfosPage } =
        await import('../../pages/valwin-admin/groups/edit-group-infos/EditGroupInfos.page');

      return { Component: EditGroupInfosPage };
    },
  },
  {
    path: ROUTES.admin.groups.pharmacies,
    lazy: async () => {
      const { GroupPharmaciesPage } =
        await import('../../pages/valwin-admin/groups/group-pharmacies/GroupPharmacies.page');

      return { Component: GroupPharmaciesPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.root,
    lazy: async () => {
      const { PharmacyAdminPage } =
        await import('../../pages/valwin-admin/pharmacies/pharmacy-admin/PharmacyAdmin.page');

      return { Component: PharmacyAdminPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.add,
    lazy: async () => {
      const { CreatePharmacyPage } =
        await import('../../pages/valwin-admin/pharmacies/create-pharmacy/CreatePharmacy.page');

      return { Component: CreatePharmacyPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.supportAccounts,
    lazy: async () => {
      const { SupportAccountsPage } =
        await import('../../pages/valwin-admin/pharmacies/support-accounts/SupportAccounts.page');

      return { Component: SupportAccountsPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.features,
    lazy: async () => {
      const { PharmacyFeaturesPage } =
        await import('../../pages/valwin-admin/pharmacies/pharmacy-features/PharmacyFeatures.page');

      return { Component: PharmacyFeaturesPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.configuration,
    lazy: async () => {
      const { PharmacyConfigPage } =
        await import('../../pages/valwin-admin/pharmacies/pharmacy-config/PharmacyConfig.page');

      return { Component: PharmacyConfigPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.pharmacists.root,
    lazy: async () => {
      const { ListPharmacistsPage } =
        await import('../../pages/valwin-admin/pharmacies/list-pharmacists/ListPharmacists.page');

      return { Component: ListPharmacistsPage };
    },
  },
  {
    path: ROUTES.admin.pharmacies.pharmacists.add,
    lazy: async () => {
      const { CreatePharmacistPage } =
        await import('../../pages/valwin-admin/pharmacies/create-pharmacist/CreatePharmacist.page');

      return { Component: CreatePharmacistPage };
    },
  },
  {
    path: ROUTES.admin.content.linings,
    lazy: async () => {
      const { LiningsPage } =
        await import('../../pages/valwin-admin/content/linings');

      return { Component: LiningsPage };
    },
  },
  {
    path: ROUTES.admin.content.services,
    lazy: async () => {
      const { ServicesPage } =
        await import('../../pages/valwin-admin/content/services');

      return { Component: ServicesPage };
    },
  },
  {
    path: ROUTES.admin.content.specialities,
    lazy: async () => {
      const { SpecialitiesPage } =
        await import('../../pages/valwin-admin/content/specialities');

      return { Component: SpecialitiesPage };
    },
  },
  {
    path: ROUTES.admin.content.pharmacies,
    lazy: async () => {
      const { DatabasePharmaciesPage } =
        await import('../../pages/valwin-admin/content/database-pharmacies');

      return { Component: DatabasePharmaciesPage };
    },
  },
  {
    path: ROUTES.admin.content.videos,
    lazy: async () => {
      const { VideosPage } =
        await import('../../pages/valwin-admin/content/videos');

      return { Component: VideosPage };
    },
  },
  {
    path: ROUTES.admin.content.tips,
    lazy: async () => {
      const { TipsPage } =
        await import('../../pages/valwin-admin/content/tips');

      return { Component: TipsPage };
    },
  },
  {
    path: ROUTES.admin.content.forms,
    lazy: async () => {
      const { FormsPage } =
        await import('../../pages/valwin-admin/content/forms');

      return { Component: FormsPage };
    },
  },
  {
    path: ROUTES.admin.content.formsEdit,
    lazy: async () => {
      const { FormsFormPage } =
        await import('../../pages/valwin-admin/content/forms');

      return { Component: FormsFormPage };
    },
  },
];
